import { BoxContainer, TextAreaLabel } from '@components/common';
import { memo } from 'react';
import css from './index.module.scss';
import { sanitizeValue } from '@helpers/utils';
import { ITaskItemProps } from '@helpers/types/task-tabs';

interface IConsigneeContainerProps {
  data: ITaskItemProps;
}

const ConsigneeContainer = (props: IConsigneeContainerProps) => {
  const { data } = props;
  return (
    <BoxContainer title="Consignee Details" className={css.mainWrapper}>
      <div className={css.boxWrapper}>
        <TextAreaLabel
          disabled
          value={sanitizeValue(data?.consignee)}
          label="Consignee Name"
          placeholder="Enter Consignee Details"
        />
      </div>
    </BoxContainer>
  );
};

export default memo(ConsigneeContainer);
